import { __decorate, __metadata, __param } from "tslib";
import { Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
var OptOutComponent = /** @class */ (function () {
    function OptOutComponent(route, router, sharedService) {
        this.route = route;
        this.router = router;
        this.sharedService = sharedService;
        this.loading = false;
        this.optingOut = false;
        this.alreadyOptedOut = false;
        this.successfullyOptedOut = false;
        this.groupName = "";
        this.groupNo = "";
        this.teamContactName = "";
        this.teamContactNumber = "";
        this.teamContactEmail = "";
        this.systemHealthModel = {};
        this.params = {};
    }
    OptOutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.sharedService.checkSystemHealth().then(function (response) {
            _this.systemHealthModel = response.data.serviceHealthChecks["UBER"];
            if (_this.systemHealthModel.health === '1') {
                _this.getAuthorisation();
            }
            else {
                _this.loading = false;
                _this.router.navigate(['unavailable']);
            }
        }, function () {
            _this.getAuthorisation();
        });
    };
    OptOutComponent.prototype.getAuthorisation = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            if (params['e']) {
                _this.params = params;
                _this.requestEmployerLogin(params);
            }
            else {
                _this.router.navigate(['error']);
            }
        });
    };
    OptOutComponent.prototype.requestEmployerLogin = function (params) {
        var _this = this;
        this.sharedService.decryptOptOutLink(params).then(function (decryptLinkResponse) {
            _this.groupName = decryptLinkResponse.body.groupName;
            _this.groupNo = decryptLinkResponse.body.groupNo;
            _this.alreadyOptedOut = decryptLinkResponse.body.accepted;
            if (!!_this.groupNo) {
                _this.sharedService.getTeamContactDetails(_this.groupNo).then(function (teamContactResponse) {
                    _this.teamContactName = teamContactResponse.name;
                    _this.teamContactNumber = teamContactResponse.telephoneNumber;
                    _this.teamContactEmail = teamContactResponse.emailAddress;
                    _this.loading = false;
                }, function () {
                    _this.loading = false;
                    _this.router.navigate(['error']);
                });
            }
            else {
                _this.loading = false;
                _this.router.navigate(['error']);
            }
        }, function () {
            _this.loading = false;
            _this.router.navigate(['error']);
        });
    };
    OptOutComponent.prototype.confirm = function () {
        var _this = this;
        this.loading = true;
        this.sharedService.acceptOptOutLink(this.params).then(function () {
            _this.successfullyOptedOut = true;
            _this.loading = false;
        }, function () {
            _this.loading = false;
            _this.router.navigate(['error']);
        });
    };
    OptOutComponent = __decorate([
        Component({
            selector: 'optOut',
            templateUrl: './app/smart-exits/opt-out/opt-out.html'
        }),
        __param(2, Inject(SharedService)),
        __metadata("design:paramtypes", [ActivatedRoute,
            Router,
            SharedService])
    ], OptOutComponent);
    return OptOutComponent;
}());
export { OptOutComponent };
//# sourceMappingURL=data:application/json;base64,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